<template>
  <div class="b-card b-card--shadow-small b-card--small">
    <div class="card-fondo">
      <div class="list-ellipsis-submenu" @click="showSubmenu = !showSubmenu">
        <div class="list-ellipsis-submenu__label" v-click-outside="config">
          <img src="../../../assets/img/ico/ico-ellipsis.svg" alt="" />
        </div>
        <div class="list-ellipsis-submenu__items" v-show="showSubmenu">
          <div class="card-fondo__actions" @click="showEditModal = true">
            {{ $t("generic.edit") }}
          </div>
          <div class="card-fondo__actions" @click="showDeleteModal = true">
            {{ $t("generic.remove") }}
          </div>
        </div>
      </div>

      <div class="card-fondo__content">
        <div class="card-fondo__ico">
          <div class="ico-box ico-box--45">
            <img :src="$fundIcons[fund.fundTypeId]" alt="Tipo de fondo" />
          </div>
        </div>
        <div class="card-fondo__title" v-text="fund.title"></div>
      </div>

      <div class="card-fondo__contributions">{{ $t("mylist.receivedContributions") }}: <strong>{{accumulatedAmount}}</strong></div>
    </div>
    <modal-dialog
      :show="showDeleteModal"
      @close="closeDeleteModal()"
      target-class="modal__card--mini"
    >
      <div class="card-wizard">
        <div class="card-wizard__title">
          <h3 class="header-3 w-70">
            {{ $t("mylist.fundsRemoveConfirmation") }}
          </h3>
        </div>
        <div class="card-wizard__actions card-wizard__actions--mt-0">
          <loading-button v-if="loading"></loading-button>
          <button
            v-else
            class="button button--primary button--block"
            @click="remove()"
          >
            {{ $t("generic.remove") }}
          </button>
          <button
            class="button button--secondary mar-t-fs-smaller button--block"
            @click="closeDeleteModal()"
          >
            {{ $t("generic.cancel") }}
          </button>
        </div>
      </div>
    </modal-dialog>
    <!-- Editar fondo //////////////////////////////////////////////////////// -->
    <modal-dialog
      :show="showEditModal"
      :showContributionsFooter="false"
      @close="showEditModal = false"
      target-class="modal__card"
    >
      <div class="flux-fondos">
        <div class="flux-fondos__header">
          <div class="flux-fondos__title">{{ $t("mylist.fundModal.title") }}</div>
        </div>

        <div class="flux-fondos__content">
          <div class="flux-fondos__left">
            <div class="ico-box ico-box--flex">
              <img :src="$fundIcons[fund.fundTypeId]" alt="Tipo de fondo" />
            </div>
          </div>
          <div class="flux-fondos__right">
            <div class="bb-form-item">
              <div class="bb-form-label">{{ $t("mylist.fundModal.fundName") }}</div>
              <input
                v-model="title"
                class="bb-form"
                type="text"
                maxlength="256"
                name="title"
                id="title"
                required=""
                @blur="titleBlur"
              />
              <div class="bb-form-error" v-show="titleHasError">
                {{ $t("generic.field_is_required") }}
              </div>
            </div>
            <div class="bb-form-item">
              <div class="bb-form-label">{{ $t("mylist.fundModal.comments") }}</div>
              <textarea
                v-model="comments"
                class="bb-form-textarea"
                type="text"
                maxlength="256"
                row="4"
                name="comments"
                id="comments"
                required=""
              />
            </div>

            <div class="flux-fondos-step__actions text-center">
              <loading-button v-if="loading"></loading-button>
              <button
                v-else
                class="button button--primary button--block"
                @click="edit()"
                :disabled="disabled"
              >
                {{ $t("generic.save") }}
              </button>
              <a
                href="#"
                class="link-delete link-delete--small mar-t-1"
                @click="removeFromEdit()"
              >
                <svg
                  width="16"
                  height="17"
                  viewBox="0 0 16 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6.66667 12.5C6.84348 12.5 7.01305 12.4298 7.13807 12.3048C7.2631 12.1798 7.33333 12.0102 7.33333 11.8334V7.83337C7.33333 7.65656 7.2631 7.48699 7.13807 7.36197C7.01305 7.23695 6.84348 7.16671 6.66667 7.16671C6.48986 7.16671 6.32029 7.23695 6.19526 7.36197C6.07024 7.48699 6 7.65656 6 7.83337V11.8334C6 12.0102 6.07024 12.1798 6.19526 12.3048C6.32029 12.4298 6.48986 12.5 6.66667 12.5ZM13.3333 4.50004H10.6667V3.83337C10.6667 3.30294 10.456 2.79423 10.0809 2.41916C9.70581 2.04409 9.1971 1.83337 8.66667 1.83337H7.33333C6.8029 1.83337 6.29419 2.04409 5.91912 2.41916C5.54405 2.79423 5.33333 3.30294 5.33333 3.83337V4.50004H2.66667C2.48986 4.50004 2.32029 4.57028 2.19526 4.6953C2.07024 4.82033 2 4.9899 2 5.16671C2 5.34352 2.07024 5.51309 2.19526 5.63811C2.32029 5.76314 2.48986 5.83337 2.66667 5.83337H3.33333V13.1667C3.33333 13.6971 3.54405 14.2058 3.91912 14.5809C4.29419 14.956 4.8029 15.1667 5.33333 15.1667H10.6667C11.1971 15.1667 11.7058 14.956 12.0809 14.5809C12.456 14.2058 12.6667 13.6971 12.6667 13.1667V5.83337H13.3333C13.5101 5.83337 13.6797 5.76314 13.8047 5.63811C13.9298 5.51309 14 5.34352 14 5.16671C14 4.9899 13.9298 4.82033 13.8047 4.6953C13.6797 4.57028 13.5101 4.50004 13.3333 4.50004ZM6.66667 3.83337C6.66667 3.65656 6.7369 3.48699 6.86193 3.36197C6.98695 3.23695 7.15652 3.16671 7.33333 3.16671H8.66667C8.84348 3.16671 9.01305 3.23695 9.13807 3.36197C9.2631 3.48699 9.33333 3.65656 9.33333 3.83337V4.50004H6.66667V3.83337ZM11.3333 13.1667C11.3333 13.3435 11.2631 13.5131 11.1381 13.6381C11.013 13.7631 10.8435 13.8334 10.6667 13.8334H5.33333C5.15652 13.8334 4.98695 13.7631 4.86193 13.6381C4.7369 13.5131 4.66667 13.3435 4.66667 13.1667V5.83337H11.3333V13.1667ZM9.33333 12.5C9.51014 12.5 9.67971 12.4298 9.80474 12.3048C9.92976 12.1798 10 12.0102 10 11.8334V7.83337C10 7.65656 9.92976 7.48699 9.80474 7.36197C9.67971 7.23695 9.51014 7.16671 9.33333 7.16671C9.15652 7.16671 8.98695 7.23695 8.86193 7.36197C8.73691 7.48699 8.66667 7.65656 8.66667 7.83337V11.8334C8.66667 12.0102 8.73691 12.1798 8.86193 12.3048C8.98695 12.4298 9.15652 12.5 9.33333 12.5Z"
                    fill="#DC3545"
                  />
                </svg>

                {{ $t("mylist.fundModal.removeFromList") }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </modal-dialog>
    <alert v-if="showAlertLocal" @retry="retry" :key="key" />
  </div>
</template>
<script>
import ModalDialog from "../../../components/ui/ModalDialog";
import LoadingButton from "../../../components/LoadingButton";
import OwnerListAlert from "./OwnerListAlert";
import { mapGetters } from "vuex";
import vClickOutside from "v-click-outside";
import CloseOnClickOutside from "../../../components/Mixins/CloseOnClickOutside";
import CanBeClosedByEscKey from "../../../Mixins/CanBeClosedByEscKey";
import HasSubMenu from "./Mixins/HasSubMenu";

export default {
  name: "FundCard",
  mixins: [CloseOnClickOutside, CanBeClosedByEscKey, HasSubMenu],
  components: {
    "modal-dialog": ModalDialog,
    "loading-button": LoadingButton,
    alert: OwnerListAlert,
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  props: {
    fund: {
      type: Object,
      required: true,
    },
    list: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showDeleteModal: false,
      showEditModal: false,
      loading: false,
      title: "",
      comments: "",
      action: "",
      titleDirty: false,
      comesFromEdit: false,
    };
  },
  computed: {
    ...mapGetters({
      showAlertKey: "showAlertKey",
      showAlert: "showAlert",
      loggedInUserHasPiggyBankEnabled: "loggedInUserHasPiggyBankEnabled",
    }),
    disabled() {
      return this.title === "";
    },
    titleHasError() {
      return this.title === "" && this.titleDirty;
    },
    showAlertLocal() {
      return this.showAlertKey === this.key && this.showAlert;
    },
    key() {
      return "fund_" + this.fund.id;
    },
    accumulatedAmount() {
      return this.$utils.formatMoney(this.fund.accumulatedAmount);
    }
  },
  methods: {
    removeFromEdit() {
      this.showEditModal = false;
      this.comesFromEdit = true;
      this.$sleep(() => {
        this.showDeleteModal = true;
      }, 100);
    },
    titleBlur() {
      this.titleDirty = true;
    },
    async getList() {
      return await this.$store.dispatch("getOwnerList");
    },
    async retry() {
      this.$store.commit("setAlertRetrying", true);
      if (this.action === "editing") {
        await this.edit();
      }
      if (this.action === "removing") {
        await this.remove();
      }
      this.$store.commit("setAlertRetrying", false);
    },
    async edit() {
      this.action = "editing";
      this.loading = true;
      try {
        const fund = {
          id: this.fund.id,
          title: this.title,
          comments: this.comments,
        };
        await this.$store.dispatch("updateFund", fund)
        await this.getList();
        this.loading = false;
        this.$alert.success(
          this.$t("mylist.fundModal.fundModifiedSuccess"),
          this.key
        );
      } catch (error) {
        console.log(error);
        this.loading = false;
        this.$alert.error(
          this.$t("mylist.fundModal.fundNotModified"),
          true,
          this.key
        );
      }
      this.showEditModal = false;
    },
    closeDeleteModal() {
      this.showDeleteModal = false;
      if (this.comesFromEdit) {
        this.comesFromEdit = false;
        this.showEditModal = false;
      }
    },
    async remove() {
      this.loading = true;
      this.action = "removing";
      try {
        await this.$store.dispatch('removeFund',this.fund)
        this.loading = false;
        // HACK per donar temps al Vue watcher del show a tancar correctament el modal
        // AIXÔ ÉS PER QUE LA CARD DEL FUND DESAPAREIX AL SER UNA OPERACIÓ ESBORRAR
        this.$sleep(() => {
          let funds = [...this.list.funds];
          funds.splice(
            funds.findIndex((fund) => fund.id === this.fund.id),
            1
          );
          this.$store.commit("setOwnerListFunds", funds);
          this.$emit("removed");
        }, 100);
        this.closeDeleteModal();
      } catch (error) {
        console.log(error);
        this.loading = false;
        this.$alert.error(
          this.$t("mylist.fundModal.fundNotRemoved"),
          true,
          this.key
        );
      }
    },
  },
  mounted() {
    this.title = this.fund.title;
    this.comments = this.fund.comments;
  },
};
</script>
